import { TextField } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { useFocusTarget } from '../../../focus/useFocusTarget';
import { useQuizControl } from '../../QuizControlProvider';
export const TextHintInput = ({
  value,
  onChange
}: {
  value?: string;
  onChange: (value: string) => void;
}) => {
  const {
    index
  } = useQuizControl();
  const ref = useFocusTarget<HTMLInputElement>(`quizList.${index}.hint`);
  const {
    t
  } = useTranslation(['build']);
  return <TextField.Root required data-sentry-element="unknown" data-sentry-component="TextHintInput" data-sentry-source-file="TextHintInput.tsx">
      <TextField.Input ref={ref} value={value} placeholder={t('quizCreateItem.text.description')} maxLength={300} onChange={e => onChange(e.target.value)} onFocus={e => {
      e.stopPropagation();
    }} className="text-heading-sm-bold" data-sentry-element="unknown" data-sentry-source-file="TextHintInput.tsx" />
    </TextField.Root>;
};
TextHintInput.displayName = 'TextHintInput';